import { SvgIcon, SvgIconProps } from '@mui/material';

const MinusIcon = (props: SvgIconProps) => {
  const { sx, ...iconProps } = props;

  return (
    <SvgIcon
      {...iconProps}
      data-testid="RemoveOutlinedIcon"
      viewBox="0 0 24 24"
      sx={[{ color: 'border.medium' }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      <path d="M19 13H5v-2h14z" />
    </SvgIcon>
  );
};

export default MinusIcon;
